import React from 'react';
import update from 'react-addons-update';
import classnames from 'classnames';
import Submenu from './Submenu';
import MapLink from '../MapLink';
import canUseDOM from '../../../common/canUseDom';
import { getLocationMenuPath } from '../../../utils/urls/chartUrls';

class DesktopLocationMenu extends Submenu {

  constructor(props) {
    super(props);
    this.analytics = this.props.analytics;
    this.locations = props.locations;
    this.state = {
      one: Object.keys(props.locations),
      one_slug: false,
      two: {},
      two_slug: false,
      three: {},
      trackingData: {
        region: '',
        subRegion: '',
        regionId: '',
        subRegionId: '',
      },
    };
  }

  loadSecondLevelNav(slug, region, name) {
    this.setState(update(this.state,
      {
        $set: {
          one: this.state.one,
          one_slug: slug,
          two: region,
          three: [],
          trackingData: {
            ...this.state.trackingData,
            region: name,
            regionId: slug,
          },
        },
      },
    ));
  }

  loadThirdLevelNav(slug, region, name) {
    if (!region && slug) {
      this.gotoMap(this.state.two[slug] || slug);
      return;
    }

    this.setState(update(this.state,
      {
        $set: {
          one: this.state.one,
          two: this.state.two,
          two_slug: slug,
          three: region,
          trackingData: {
            ...this.state.trackingData,
            subRegion: name,
            subRegionId: slug,
          },
        },
      },
    ));
  }

  gotoMap(nodeOrSlug) {
    if (canUseDOM) {
      const node = typeof nodeOrSlug === 'string' ? null : nodeOrSlug;
      const slug = typeof nodeOrSlug === 'string' ? nodeOrSlug : nodeOrSlug.slug;
      window.location.assign(getLocationMenuPath(node, slug));
    }
  }

  clickedCustomLocation = () => {}

  render() {
    const active = classnames({
      desktopLocationMenu: true,
      active: true,
    });

    return (
      <div id="locationMenu" className={active}>
        <div className="locations container">
          <div className="row">
            <div className="region-column">
              <ul>
                {
                  this.state.one.map((region, index) => {
                    let oneActive = '';
                    if (this.state.two) {
                      oneActive = classnames({
                        active: this.state.one_slug === region,
                      });
                    }

                    if (this.locations[region].name) {
                      return (
                        <RegionLink
                          key={index}
                          className={oneActive}
                          onClick={this.loadSecondLevelNav.bind(this, region, this.locations[region].children, this.locations[region].name)}
                          region={this.locations[region]}
                        />
                      );
                    }
                  })
                }
              </ul>
            </div>
            <div
              className="region-column"
              style={{ display: this.state.one_slug ? 'block' : 'none' }}
            >
              <ul>
                {(() => {
                  const twoKeys = Object.keys(this.state.two);
                  return twoKeys.map((region, index) => {
                    let twoActive = '';
                    if (this.state.two_slug) {
                      twoActive = classnames({
                        active: this.state.two_slug === region,
                      });
                    }

                    return (
                      <RegionLink
                        key={index}
                        className={twoActive}
                        onClick={this.loadThirdLevelNav.bind(this, region, this.state.two[region].children, this.state.two[region].name)}
                        region={this.state.two[region]}
                        trackingData={this.state.trackingData}
                        doTrackEvent={this.props.doTrackEvent}
                      />
                    );
                  });
                })()}
              </ul>
            </div>
            <div
              className="region-column"
              style={{ display: this.state.two_slug ? 'block' : 'none' }}
            >
              <ul>
                {(() => {
                  const three = Object.keys(this.state.three);
                  return three.map((region, index) => (
                    <RegionLink
                      key={index}
                      onClick={this.gotoMap.bind(this, this.state.three[region])}
                      region={this.state.three[region]}
                      trackingData={this.state.trackingData}
                      doTrackEvent={this.props.doTrackEvent}
                    />
                    ));
                })()}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


class RegionLink extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    if (this.props.region.children) {
      return (
        <li onClick={this.props.onClick} className={this.props.className}>
          <a href="#">
            {this.props.region.name} &nbsp;
            <i className="fa fa-angle-right" />
          </a>
        </li>
      );
    }
    return (
      <MapLink {...this.props} slug={this.props.region.slug} doTrackEvent={this.props.doTrackEvent}>
        {this.props.region.name}
      </MapLink>
    );
  }
}


export default DesktopLocationMenu;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/menus/DesktopLocationMenu.js